import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/Logo.png";

const FooterAreaTwo = () => {
  return (
    <footer
      className="footer-wrapper footer-layout2"
      style={{ backgroundImage: "url(assets/img/bg/footer-bg2-1.png)" }}
    >
      <div className="container">
        <div className="widget-area">
          <div className="row justify-content-between">
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget widget-about">
                <img
                  src="assets/img/Logo.png"
                  onError={(e) => (e.currentTarget.src = logo)}
                  className="mb-5"
                  alt="Silverline"
                  width={250}
                />
                <p className="footer-text ">
                  We buy and sell quality used cars with hassle-free part
                  exchange services. Get the best deals and trade with
                  confidence!
                </p>
                <div className="social-btn style3">
                  <Link
                    to="https://www.facebook.com/profile.php?id=61573496728160"
                    tabIndex={-1}
                  >
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link
                    to="https://www.instagram.com/silverlineautos"
                    tabIndex={-1}
                  >
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="https://g.co/kgs/3gsftyf" tabIndex={-1}>
                    <i className="fab fa-google" />
                  </Link>
                  <Link
                    to="https://www.tiktok.com/@silverlineauto"
                    tabIndex={-1}
                  >
                    <i className="fab fa-tiktok" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Company</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About</Link>
                    </li>
                    <li>
                      <Link to="/showroom">Showroom</Link>
                    </li>
                    <li>
                      <Link to="/all-services">Car Repair/MOT</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Our Services</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to="/all-services">
                        Mobile tyre fitting service
                      </Link>
                    </li>
                    <li>
                      <Link to="/all-services">Services</Link>
                    </li>
                    <li>
                      <Link to="/all-services">MOT's</Link>
                    </li>
                    <li>
                      <Link to="/all-services">Cambelts</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">Contact</h3>
                <div className="widget-contact2">
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <div className="contact-grid-details">
                      <p>Address</p>
                      <h6>
                        UNIT 2 POOL ROAD INDUSTRIAL ESTATE
                        <p />
                      </h6>
                    </div>
                  </div>
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-phone-alt" />
                    </div>
                    <div className="contact-grid-details">
                      <p>Phone Number</p>
                      <h6>
                        <Link to="tel: 07496360002"> 07496360002</Link>
                        <br />
                        <Link to="tel: 02476347151"> 02476347151</Link>
                        <p />
                      </h6>
                    </div>
                  </div>
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-envelope" />
                    </div>
                    <div className="contact-grid-details">
                      <p>Email Address</p>
                      <h6>
                        <Link to="mailto:inquiry@silverlineautoltd.co.uk">
                          inquiry@silverlineautoltd.co.uk
                        </Link>
                        <p />
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-3 justify-content-md-between justify-content-center">
            <div className="col-auto align-self-center">
              <p className="copyright-text text-center">
                © <Link to="/">Silverline</Link> 2025 | All Rights
                Reserved,Created by <a href="https://digioon.com/">Digioon</a>
              </p>
            </div>
            <div className="col-auto">
              <div className="footer-links">
                <Link to="/Terms-and-condition">Tarms &amp; Condition</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAreaTwo;
